import React from 'react';
import PropTypes from 'prop-types';
import TextField from '@mui/material/TextField';
import MenuItem from '@mui/material/MenuItem';

import Utilisateur from 'components/Shared/Utilisateur';

class UtilisateurSelect extends React.Component {
    render() {
        const { value, onChange, utilisateurs, isRequired, error, disabled, onlyUserId } = this.props;


        if (utilisateurs === null) {
            return null;
        }

        let selected = value;
        if (utilisateurs.length === 0 || value === 0) {
            selected = '';
        }

        return (
            <TextField
                select
                name="utilisateurId"
                label="Utilisateur"
                value={selected}
                onChange={onChange}
                required={isRequired}
                error={error !== undefined}
                fullWidth
                disabled={disabled}
            >

                {utilisateurs.map(utilisateur => (
                    <MenuItem key={utilisateur.id} value={utilisateur.id} disabled={onlyUserId !== 0 && onlyUserId !== utilisateur.id}>
                        <Utilisateur utilisateur={utilisateur} format="simple" />
                    </MenuItem>
                ))}

            </TextField>
        );
    }
}

UtilisateurSelect.propTypes = {
    value: PropTypes.number.isRequired,
    onChange: PropTypes.func.isRequired,
    isRequired: PropTypes.bool.isRequired,
    error: PropTypes.object,
    utilisateurs: PropTypes.array,
    isLoading: PropTypes.bool.isRequired,
    disabled: PropTypes.bool.isRequired,
    onlyUserId: PropTypes.number.isRequired,

};

export default UtilisateurSelect;